import { Navigate, Outlet } from 'react-router-dom';
import { Center, Text } from '@mantine/core';

import { useActiveClientId } from '../hooks/useActiveClientId';
import { monitoringPaths } from '../utils/monitoringPaths';

const AuthPending = () => (
  <Center p={25}>
    <Text size="sm" c="var(--quo-grey-50)">
      Loading…
    </Text>
  </Center>
);

const MissingOrganization = () => (
  <Center p={25}>
    <Text size="md">Unable to determine your organization. Please refresh or contact support.</Text>
  </Center>
);

/**
 * Redirects the bare `/supplychain/monitoring` route to the user's own client,
 * keeping the active client always present in the URL.
 */
export const MonitoringRedirect = () => {
  const { ownClientId, isAuthPending } = useActiveClientId();

  if (isAuthPending) return <AuthPending />;
  if (ownClientId == null) return <MissingOrganization />;
  return <Navigate to={monitoringPaths.overview(ownClientId)} replace />;
};

/**
 * Guards the `/supplychain/monitoring/:client` subtree. When the `:client`
 * param is not a client the user may act on behalf of, redirect to their own
 * client; otherwise render the nested monitoring pages.
 */
export const MonitoringClientLayout = () => {
  const { isValid, ownClientId, isAuthPending } = useActiveClientId();

  if (isAuthPending) return <AuthPending />;

  if (!isValid) {
    if (ownClientId == null) return <MissingOrganization />;
    return <Navigate to={monitoringPaths.overview(ownClientId)} replace />;
  }

  return <Outlet />;
};
